import { jsx } from 'react/jsx-runtime';
import { forwardRef, useCallback } from 'react';
import classNames from 'classnames';

const Link = /*#__PURE__*/ forwardRef(({ size = 'base', variant, disabled, className, children, onClick, ...props }, ref)=>{
    const classes = classNames('cb-text-link', size, variant, {
        disabled
    }, className);
    const handleClick = useCallback((e)=>{
        if (disabled) {
            e.preventDefault();
            return false;
        }
        onClick?.(e);
    }, [
        disabled,
        onClick
    ]);
    return jsx("a", {
        ref: ref,
        ...props,
        "aria-disabled": disabled,
        className: classes,
        onClick: handleClick,
        children: children
    });
});
Link.displayName = 'TextLink.Link';

export { Link as default };
//# sourceMappingURL=TextLink.Link.es.js.map
